export const GA_SETTINGS_PROP_FIXTURE = {
    guestPartnerId: 'find_better_fake_data',
    isActive: true,
    userPartnerId: 'de57256e_a1606badad63373897f4856e6ea677d5',
};
